import { OrderedTopic } from '@apps/materiality-tracker/api/materiality-assessment';
import type { PrioritizedAssessmentData } from '@apps/materiality-tracker/components/assessment-insights/types';
import { isDefined } from '@utils/index';
import { roundTo } from '@utils/number';

export const extendCustomTopics = (originalTopics: PrioritizedAssessmentData[], newOrderedTopics: OrderedTopic[]) => {
  const topicsMap = new Map(originalTopics.map((topic) => [topic.code, topic]));
  let priority = 1;
  return newOrderedTopics.reduce<PrioritizedAssessmentData[]>((topics, { code, disabled }) => {
    const topic = topicsMap.get(code);
    if (topic) {
      topics.push({ ...topic, priority: disabled ? -1 : priority, disabled });
      if (!disabled) {
        priority += 1;
      }
    }
    return topics;
  }, []);
};

export const NOT_FOUND_CATEGORY_MESSAGE = 'Invalid category. Please try a different selection.';

export const isScoreInRange = ({
  score,
  min,
  max,
}: {
  score: number | undefined;
  min: number | undefined;
  max: number | undefined;
}) => {
  return isDefined(score) && (min ? score >= min : true) && (max ? score < max : true);
};

export const normalizeByRelativeScore = (data: PrioritizedAssessmentData[]) => {
  if (!data || data.length === 0) {
    return [];
  }

  const maxRelativeScore = Math.max(...data.map((item) => item.relativeScore ?? 0));

  // Handle case where max score is 0 to avoid division by zero
  if (maxRelativeScore === 0) {
    // If max score is 0, keep the original relative score
    return data.map((item) => ({
      ...item,
      normalizedScore: item.relativeScore,
    }));
  }

  return data.map((item) => {
    return {
      ...item,
      normalizedScore: item.relativeScore ? roundTo((item.relativeScore / maxRelativeScore) * 100) : undefined,
    };
  });
};
